import templateCompiler from './template.art';
import { 
  FORM_GROUP_IN_HOME,
  FORM_MAP,
} from "../constants/form.constants";

const template = templateCompiler(FORM_MAP);
export default function FormModule() {
    //let callbacks = bindCallbacks(CONVERT_LIST, callback);
    let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
    let fragments = [
        {
            // 向末尾追加控件
            action: ACTIONS.AFTER,
            // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
            target: 'view-tab',
            // 定义控件的以及图标，文字等信息
            template: '<gtab text="phantom_online:toolbar.tabs.form.title" name="form-tab" group="toolbar-tab" body="fv--form-tab-paddle" @portfolio.unsupport></gtab>',
        },
        {
            action: ACTIONS.APPEND,
            target: 'toolbar-tab-bodies',
            template: template,
        },
        {
            action: ACTIONS.REMOVE,
            target: FORM_GROUP_IN_HOME
        },
      // {
      //   // 向末尾追加控件
      //   action: ACTIONS.APPEND,
      //   // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
      //   target: 'form-to-sheet-container',
      //   // 定义控件的以及图标，文字等信息
      //   template: `<dropdown-button @cannotBeDisabled name=${FORM_MAP.combineForms.name} @tooltip tooltip-title=${FORM_MAP.combineForms.title} icon-class=${FORM_MAP.combineForms.icon} text=${FORM_MAP.combineForms.title}>${FORM_MAP.combineForms.title}</dropdown-button>`,
      // },
      //...callbacks,
    ];
    return {fragments};
}
